// reveal on scroll
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}}),{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

// duplicate marquee for seamless loop
const tr=document.getElementById('marqueeTrack');if(tr)tr.innerHTML+=tr.innerHTML;

// FAQ accordion
document.querySelectorAll('.faq-q').forEach(btn=>btn.addEventListener('click',()=>{
  const item=btn.parentElement,ans=item.querySelector('.faq-a'),open=item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(o=>{o.classList.remove('open');o.querySelector('.faq-a').style.maxHeight=0});
  if(!open){item.classList.add('open');ans.style.maxHeight=ans.scrollHeight+'px'}
}));

// counters + progress bars when dashboard is visible
const dash=document.querySelector('.dash-mock');
const dio=new IntersectionObserver(es=>{if(!es[0].isIntersecting)return;dio.disconnect();
  dash.querySelectorAll('[data-count]').forEach(el=>{
    const end=+el.dataset.count,t0=performance.now();
    (function tick(t){const p=Math.min((t-t0)/1400,1);el.textContent=Math.round(end*(1-Math.pow(1-p,3)));if(p<1)requestAnimationFrame(tick)})(t0);
  });
  dash.querySelectorAll('.fl').forEach(el=>el.style.width=el.dataset.w);
},{threshold:.3});
if(dash)dio.observe(dash);
// mobile menu
const navBar=document.querySelector('.inv nav .bar');
if(navBar)document.querySelector('.burger').addEventListener('click',()=>navBar.classList.toggle('open'));
document.querySelectorAll('.nav-links a').forEach(a=>a.addEventListener('click',()=>navBar.classList.remove('open')));


// newsletter
const nl=document.getElementById('nlForm');
if(nl)nl.addEventListener('submit',e=>{e.preventDefault();nl.innerHTML='<span style="padding:12px 20px;font-size:14px">You\u2019re on the list \u2713</span>';});

// Add-to-cart via AJAX: fa scattare l'evento product_added_to_cart per i pixel
document.addEventListener('click',function(e){
  var a=e.target.closest('a[href*="/cart/add"]');if(!a)return;
  e.preventDefault();
  var u=new URL(a.getAttribute('href'),location.origin);
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(u.searchParams.get('id'),10),quantity:parseInt(u.searchParams.get('quantity')||'1',10)})})
    .then(function(r){if(!r.ok)throw 0;setTimeout(function(){location.href='/cart'},700)})
    .catch(function(){location.href=a.getAttribute('href')});
});
document.addEventListener('submit',function(e){
  var f=e.target;if(!f.action||f.action.indexOf('/cart/add')===-1)return;
  e.preventDefault();
  fetch('/cart/add.js',{method:'POST',body:new FormData(f)})
    .then(function(r){if(!r.ok)throw 0;setTimeout(function(){location.href='/cart'},700)})
    .catch(function(){f.removeEventListener&&location.assign(f.action+'?'+new URLSearchParams(new FormData(f)))});
});
